import { LabelHTMLAttributes } from "react";
import { LabelProps } from "@common/types";
import { LabelPrimitive } from "@app/components/ui/label";
import { useDocumentDirection } from "@app/hooks";
import { cn } from "@app/lib/utils";

const variants = {
  success: "text-success",
  danger: "text-destructive",
  default: "text-foreground",
};

export function Label({
  label,
  children,
  variant,
  className,
  ...props
}: LabelProps & LabelHTMLAttributes<HTMLLabelElement>) {
  const controlDir = useDocumentDirection();

  return label ? (
    <LabelPrimitive
      className={cn("block max-w-full me-auto", className)}
      {...props}
      dir={props.dir || controlDir}
    >
      <div
        className={cn(
          "mb-2 block w-full text-start text-sm font-semibold leading-5",
          controlDir === "rtl" ? "text-right" : "text-left",
          variants[variant || "default"],
        )}
      >
        {label}
      </div>
      {children}
    </LabelPrimitive>
  ) : (
    <>{children}</>
  );
}
